import "./Loading.css";
import logoImg from "../../../assets/custom/classic/IBOPE.svg";
import packageInfo from '../../../../package.json';


const Loading = ({ show , isMobile }) => {
  return (
  <div id="loading" style={{
    display: show ? 'flex' : 'none', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh' 
  }}>
    <div style={{
      display: 'table-cell',
      verticalAlign: 'middle'
    }}>
      <div style={{
        width: '100%',
        textAlign: 'center',
      }}>
        <img
          style={{
            height: isMobile ? "65px" : "150px",
            width: "auto"
          }}
          src={logoImg}
          alt="Fifty5 Blue Logo"
        />
        <div className="spinner" style={{
          position: 'absolute',
          top: 100,
          left: '50%',
          marginLeft: -20
        }}></div>
      </div>
    </div>
    <footer
      style={{
        width: '100%',
        textAlign: 'center',
        position: 'absolute',
        bottom: 10,
        left: 0
      }}
    >
      <p id="appName">
        {packageInfo.name}
      </p>
      <p style={{
        color:"#ccc"
      }}>
        {`v${packageInfo.version}`}
      </p>
    </footer>
  </div>
  );
}
export default Loading;
